import React from 'react';
import PropTypes from 'prop-types';
import MomentPropTypes from 'react-moment-proptypes';
import moment from 'moment';
import { LanguageService as i18n } from '../../services';
import { FilterTag } from '../Styled';
import {
  DATE_WITH_DOTS,
  DEFAULT_DATE,
  DEFAULT_DATE_TIME,
} from '../../utils/constants/timeFormats';
import {
  connectionStatusOptions,
} from '../../modules/Telematics/TelematicAccountDetails/Components/DevicesTable.constants';
import { statusOptions } from '../../modules/Orders/Components/OrdersTable.constants';

const valuesWithLabel = [...connectionStatusOptions, ...statusOptions];
const DATE_INPUT_FORMATS = [
  DEFAULT_DATE,
  DATE_WITH_DOTS,
  DEFAULT_DATE_TIME,
  'DD-MM-YYYY HH:mm',
  'YYYY-MM-DD',
  'YYYY-MM-DD HH:mm',
  'YYYY/MM/DD',
  'YYYY-MM-DDTHH:mm:ss',
  'YYYY-MM-DDTHH:mm:ssZ',
  'YYYY-MM-DDTHH:mm:ss.SSSZ',
  moment.ISO_8601,
];

const hasDateSeparators = (value) => /[./-]/.test(value);

const toString = (value) => {
  if (value && moment.isMoment(value) && value.isValid()) {
    return value.format(DEFAULT_DATE);
  }

  if (value && (value instanceof Date || typeof value === 'string')) {
    const m = value instanceof Date
      ? moment(value)
      : moment(value, DATE_INPUT_FORMATS, true);
    if (m.isValid() && (value instanceof Date || hasDateSeparators(value))) {
      return m.format(DEFAULT_DATE);
    }
  }

  const label = valuesWithLabel.find((op) => op.value === value)?.label;
  return label ? i18n.t(label) : value;
};

const parseValues = (values) => values.map(toString).join(', ');

const FilterTagComponent = ({ filterName, value, onRemove }) => (
  <FilterTag
    key={filterName}
    closable={!!onRemove}
    onClose={() => onRemove(filterName)}
    color="blue"
  >
    <b>
      {i18n.t(`PROPERTIES.${filterName}`)}
      :
      {' '}
    </b>
    {' '}
    {parseValues(value)}
  </FilterTag>
);

FilterTagComponent.propTypes = {
  filterName: PropTypes.string.isRequired,
  value: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, MomentPropTypes.momentObj])).isRequired,
  onRemove: PropTypes.func.isRequired,
};

export default FilterTagComponent;
